module.exports = __webpack_public_path__ + "media/images/mobile/222-7e95033ca83f98bea0845860fb1c0560.jpg";